const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
const bodyElement = document.body;
const CSS_BODY_LOCKED = 'mix-bodyIsLocked';
const CSS_SNEEZEGUARD = 'mix-sneezeGuard';
let scrollPosition = 0;
const modalSneezeGuardElement = document.createElement('div');
modalSneezeGuardElement.classList.add(CSS_SNEEZEGUARD);

const bodyLockService = {
    lock: () =>  {
        bodyElement.classList.add(CSS_BODY_LOCKED);
        if (isIOS) {
            scrollPosition = window.pageYOffset;
            bodyElement.style.overflow = 'hidden';
            bodyElement.style.position = 'fixed';
            bodyElement.style.top = `-${scrollPosition}px`;
            bodyElement.style.width = '100%';
            return;
        }
        bodyElement.style.overflow = 'hidden';
        document.body.appendChild(modalSneezeGuardElement);
        document.body.addEventListener('click', bodyLockService.handleBodyClick);
    },
    unlock: () => {
        bodyElement.classList.remove(CSS_BODY_LOCKED);
        if (isIOS) {
            bodyElement.style.removeProperty('overflow');
            bodyElement.style.removeProperty('position');
            bodyElement.style.removeProperty('top');
            bodyElement.style.removeProperty('width');
            window.scrollTo(0, scrollPosition);
            return;
        }
        bodyElement.style.overflow = '';
        document.body.removeEventListener('click', bodyLockService.handleBodyClick);
        modalSneezeGuardElement.remove();
    },
    handleBodyClick: (e) => {
        if (e.target.matches('.closeQuoteTipPanel')) {
            tipViewPanel.close()
            bodyLockService.unlock();
        }
        if (e.target.matches('.mix-sneezeGuard')) {
            document.querySelector('.modal_isActive') && document.querySelector('.modal_isActive').classList.remove('modal_isActive');
            bodyLockService.unlock();
        }
    }
};
export default bodyLockService;